import createPromiseSaga from 'lib/createPromiseSaga';
import { all, take, actionChannel } from 'redux-saga/effects';
import * as actions from './actions';
import * as api from 'modules/global/api';

export function* optIn() {
  const channel = yield actionChannel(actions.OPT_IN);
  while (true) {
    const action = yield take(channel);
    yield* createPromiseSaga(action, api.keepUserLogin)();
  }
}

export default function* sagas(i18n) {
  yield all([optIn()]);
}
